import { useCallback, useContext, useState } from "react"
import { Item } from "../../../../../../../utils/types/generals"
import { useInput } from "./useInput"
import { useTranslation } from "react-i18next"
import { GlobalContext } from "../../../../../../../contexts/Global"
import { Status } from "../../../../../../../utils/enums"
import { getStatus } from "../../../../../../../hooks/status"
import { getArea, getDepartments, getUsers } from "../../../../../../../utils/methods/geServiceWithItemsFormat"
import { fileTypeText } from "../constans/menu"


const useGetData = () => {
  const [items, setItems] = useState<{ [x: string]: Item[] }>({})
  const { input } = useInput({ items })
  const { t } = useTranslation()
  const { colors } = useContext(GlobalContext)
  const [departments, setDepartments] = useState<any[]>([])

  const getData = useCallback(async () => {
    getItemStatus()
    getUsersService()
    getAreasService()
    getDepartmentService()
    setItems((prev) => ({
      ...prev,
      //createYear: getPreviousYears(),
      /* month: monthYear.map((e) => ({
        ...e,
        value: e.value + 1,
      })), */
      fileType: fileTypeText.map((e) => ({
        ...e,
        value: e.value,
      })),
    }))

  }, [])



  const getItemStatus = async () => {
    const statusList = [Status.ACTIVE, Status.INACTIVE]

    setItems((prev) => ({
      ...prev,
      status: statusList.map((item) => {
        const status = getStatus(item, colors, t)
        return {
          label: status.text,
          value: status.value,
        }
      }),
    }))
  }

  const getUsersService = async () => {
    const { items } = await getUsers({ addUserLogged: true })
    setItems((prev) => ({
      ...prev,
      user: items
    }))
  }

  const getAreasService = async () => {
    const responseAreas = await getArea()

    setItems((prev) => ({
      ...prev,
      area: responseAreas,
    }))
  }

  const getDepartmentService = async () => {
    const departments = await getDepartments()
    setDepartments(departments)
  }

  const handleItemsByExternal = ({
    name,
    value,
  }: {
    name: string
    value: any
  }) => {
    setItems((prev) => ({
      ...prev,
      [name]: value,
    }))
  }


  return { input, getData, items, departments, handleItemsByExternal }
}

export { useGetData }
